/*
 * Module for the Contribution Rate Detail's age rate partial view
*/
rs.module("content/system/configuration/contributionrates/detail/agerate",

    [
        "controls/data/grid"
    ],

    function (gridModule) {

        //
        // Initialize
        //
        function initialize(jsSelectors, backendUrl, lrsGridApi) {

            // Unpack js selectors
            var criteria = $.js(jsSelectors.criteria);

            var tablePeriodSelect = criteria.js(jsSelectors.tablePeriodSelect);
            var tableMaintenanceLink = criteria.js(jsSelectors.tableMaintenanceLink, { required: false });

            // Add listeners to the table period select
            tablePeriodSelect.change(function () {

                gridModule.update(
                    backendUrl,

                    {
                        ageRateKey: tablePeriodSelect.val()
                    },

                    lrsGridApi.agGridApi,

                    function done(gridUpdate) {

                        // Table Maintenance Link
                        tableMaintenanceLink.attr("href", gridUpdate.context.maintenanceLink);

                    }
                );

            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);